import { Paragraph, PromotionCard } from '@purpurds/purpur';
import { TeliaButton, TeliaCtaLink } from '@teliads/components/react';
import './PromotionCard.scss';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import AlertToast from 'components/custom/alert-toast/AlertToast';
import ContactUsModal from 'components/custom/contanct-us-modal/ContactUsModal';
import { PromotionCardProps } from 'pages/FlexibleSolutionsTemplate/models';
import { renderRichText } from 'utils/rich-text-render';

const PromotionCardPurPur = ({ title, preamble, cta, type }: PromotionCardProps) => {
  const { t } = useTranslation();
  const [isContactUsFormOpen, setIsContactUsFormOpen] = useState(false);

  const [isAlertToastOpen, setIsAlertToastOpen] = useState(false);

  return (
    <>
      {cta.url === '' && (
        <>
          <ContactUsModal
            isOpen={isContactUsFormOpen}
            close={() => setIsContactUsFormOpen(false)}
            nextStep={() => {
              setIsContactUsFormOpen(false);
              setTimeout(() => setIsAlertToastOpen(true), 250);
            }}
          />

          <AlertToast
            variant="success"
            preamble={t('contact_us_modal.success')}
            onClose={() => setIsAlertToastOpen(false)}
            isOpen={isAlertToastOpen}
          />
        </>
      )}
      <div className="promotion-card__wrapper">
        <PromotionCard title={title || ''} variant={type} hasGradient className="promotion-card">
          <div className="promotion-card__content">
            <Paragraph>{preamble ? renderRichText(preamble.json) : <></>}</Paragraph>
            {cta.url === '' ? (
              <TeliaButton
                variant={type === 'primary' ? 'primary-white' : 'primary'}
                onClick={() => setIsContactUsFormOpen(!isContactUsFormOpen)}
                text={cta.text || t('footer.contact_us')}
                //@ts-ignore
                rightIcon={{
                  name: 'arrow-right',
                  size: 'md',
                  allyTitle: 'Call to action',
                }}
              />
            ) : (
              <TeliaCtaLink
                tabIndex={0}
                href={cta.url}
                variant={type === 'primary' ? 'primary-white' : 'primary'}
              >
                {cta.text || t('read_more')}
              </TeliaCtaLink>
            )}
          </div>
        </PromotionCard>
      </div>
    </>
  );
};

export default PromotionCardPurPur;
